export const actionTypes = {
  SET_TYPE: 'MY_TAXES.OPERATIONS_HISTORY.LIST_FILTERS.SET_TYPE',
  SET_TAX_AUTHORITY: 'MY_TAXES.OPERATIONS_HISTORY.LIST_FILTERS.SET_TAX_AUTHORITY',
  SET_TAX_TYPE: 'MY_TAXES.OPERATIONS_HISTORY.LIST_FILTERS.SET_TAX_TYPE',
  SET_ADJUSTMENT_SHOW: 'MY_TAXES.OPERATIONS_HISTORY.LIST_FILTERS.SET_ADJUSTMENT_SHOW',
};

export function setType(typeOption) {
  return {
    type: actionTypes.SET_TYPE,
    payload: typeOption,
  };
}

export function setTaxAuthority(taxAuthorityOption) {
  return {
    type: actionTypes.SET_TAX_AUTHORITY,
    payload: taxAuthorityOption,
  };
}

export function setTaxType(taxTypeOption) {
  return {
    type: actionTypes.SET_TAX_TYPE,
    payload: taxTypeOption,
  };
}

export function setAdjustmentShow(value) {
  return {
    type: actionTypes.SET_ADJUSTMENT_SHOW,
    payload: value,
  };
}
